import React from "react"

import { AnchorProps } from "shared/ui/link/Anchor"

import { ProjectModel } from "features/project-management/types/ProjectModel"

import { ProjectsOverviewCardView } from "./ui/ProjectsOverviewCardView"

export interface ProjectsOverviewCardProps extends Omit<AnchorProps, "data"> {
  projectID: string
  model: ProjectModel
}

export const ProjectsOverviewCard = React.memo(
  React.forwardRef(
    (
      props: ProjectsOverviewCardProps,
      ref?: React.ForwardedRef<HTMLAnchorElement>
    ) => {
      return <ProjectsOverviewCardView ref={ref} {...props} />
    }
  )
)
